import { Container } from "react-bootstrap"

import React from 'react';
import '../data/Skills.css';
import htmlLogo from '../assets/img/html-logo.svg';
import cssLogo from '../assets/img/CSS.png';
import javaLogo from '../assets/img/java-logo.svg';
import javascriptLogo from '../assets/img/JS.png';
import reactLogo from '../assets/img/react-logo.svg';
import springLogo from '../assets/img/springio-logo.svg';
import restapi from '../assets/img/Rest.png';
import pythonLogo from '../assets/img/Python.png';
import flutterLogo from '../assets/img/flutter-image.png';
import agileLogo from '../assets/img/Agile.png';
import mysqlLogo from '../assets/img/MySQL.png';
import postgreSQL from '../assets/img/PostgreSQL.png';
import MongoDB from '../assets/img/MongoDB.png';
import JunitLogo from '../assets/img/Junit.png';
import Docker from '../assets/img/Docker.png';
import Git from '../assets/img/git-logo.png';
import JIRA from '../assets/img/JIRA.png';
import AWSLogo from '../assets/img/AWS.png';

import { useTheme, DARK, LIGHT } from '../context/ThemeContext';
import { useState } from 'react';



/* const skillsData = [
    { name: 'Java', logo: javaLogo  },
    { name: 'Spring Boot', logo: springLogo  },
    { name: 'Rest API', logo: restapi  },
    { name: 'Flutter', logo: flutterLogo },
   // { name: 'Python', logo: pythonLogo  },
    { name: 'Agile', logo: agileLogo },
    { name: 'HTML', logo: htmlLogo  },
    { name: 'CSS', logo: cssLogo  },
    { name: 'JavaScript', logo: javascriptLogo },
    { name: 'React.js', logo: reactLogo },
    { name: 'MySQL', logo: mysqlLogo },
    { name: 'PostgreSQL', logo: postgreSQL },
    { name: 'MongoDB', logo: MongoDB },
    { name: 'JUnit', logo: JunitLogo },
    { name: 'Git', logo: Git },
    { name: 'Docker', logo: Docker },
    { name: 'JIRA', logo: JIRA },
    { name: 'Amazon Web Services', logo: AWSLogo },

]; */


const skillGroups = [
  {
    title: 'Backend',
    colorKey: 'accent',
    skills: [
      'Java', 'Spring Boot', 'Spring Security', 'Spring MVC',
      'Hibernate', 'JPA', 'REST API', 'GraphQL', 'Microservices',
    ],
  },
  {
    title: 'Frontend',
    colorKey: 'accentPurple',
    skills: [
      'Angular', 'React.js', 'TypeScript', 'JavaScript',
      'Redux', 'HTML5', 'CSS3', 'Bootstrap',
    ],
  },
  {
    title: 'Database',
    colorKey: 'accentGreen',
    skills: [
      'MySQL', 'PostgreSQL', 'MongoDB', 'Redis', 'Hibernate ORM', 'JPA',
    ],
  },
  {
    title: 'Cloud & DevOps',
    colorKey: 'accentOrange',
    skills: [
      'AWS', 'Microsoft Azure', 'Docker', 'CI/CD', 'Git', 'GitHub','Linux',
    ],
  },
  {
    title: 'Architecture & Practices',
    colorKey: 'accentYellow',
    skills: [
      'Microservices', 'System Design', 'Design Patterns',
      'Agile / Scrum', 'TDD', 'Code Review',
    ],
  },
  {
    title: 'Testing & Quality',
    colorKey: 'accentGreen',
    skills: [
      'JUnit', 'Mockito', 'Integration Testing',
      'SonarQube', 'Code Coverage', 'CI Test Automation',
    ],
  },
  {
    title: 'Tools',
    colorKey: 'accentYellow',
    skills: [
      'JIRA', 'Maven', 'Gradle', 'IntelliJ IDEA', 'VS Code', 'Postman', 'Swagger',
    ],
  },
  {
    title: 'Soft Skills & Leadership',
    colorKey: 'accentPurple',
    skills: [
      'Technical Mentoring', 'Code Review', 'Cross-functional Collaboration',
      'Requirement Analysis', 'Technical Documentation', 'Problem Solving',
    ],
  },
];
 
const Skills = () => {
  const { isDark } = useTheme();
  const t = isDark ? DARK : LIGHT;
  const [hoveredGroup, setHoveredGroup] = useState(null);
 
  return (
    <section id="skills" style={{ background: t.bg, padding: '60px 0', transition: 'background 0.3s' }}>
      <Container>
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          {/* <div style={{ fontSize: '11px', fontWeight: 600, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px' }}>
            Expertise
          </div> */}
          <div style={{ fontSize: '26px', fontWeight: 700, letterSpacing: '3px', textTransform: 'uppercase', color: t.accent, marginBottom: '8px'  }}>  🌟  My Areas of Expertise  🌟  </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '14px' }}>
          {skillGroups.map((group, gi) => {
            const color = t[group.colorKey];
            const hovered = hoveredGroup === gi;
            return (
              <div
                key={group.title}
                onMouseEnter={() => setHoveredGroup(gi)}
                onMouseLeave={() => setHoveredGroup(null)}
                style={{
                  background: t.bgAlt,
                  border: `1px solid ${hovered ? color + '55' : t.border}`,
                  borderRadius: '12px',
                  padding: '20px 22px',
                  transition: 'border-color 0.2s, box-shadow 0.2s',
                  boxShadow: hovered ? t.shadow : 'none',
                }}
              >
                <div style={{
                  fontSize: '11px', fontWeight: 600, letterSpacing: '2px',
                  textTransform: 'uppercase', color,
                  marginBottom: '14px', paddingBottom: '10px',
                  borderBottom: `1px solid ${t.border}`,
                }}>
                  {group.title}
                </div>
 
                {/* Skill chips */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '7px' }}>
                  {group.skills.map((skill) => (
                    <span key={skill} style={{
                      background: t.tagBg,
                      border: `1px solid ${t.tagBorder}`,
                      color: t.tagColor,
                      fontSize: '12px', fontWeight: 500,
                      padding: '4px 12px', borderRadius: '20px',
                    }}>
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

/* const Skills = () => {
    return (
        <div className="skills-section" id="skills">
            <h2>My Areas of Expertise 🌟 </h2>
            <div className="skills-grid">
                {skillsData.map((skill, index) => (
                    <div className="skill-item" key={index}>
                        <img src={skill.logo} alt={`${skill.name} logo`} className="skill-logo" />
                        <p>{skill.name}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}; */

export default Skills;
